import React from 'react';
import MC_OPEN from './mc_lid_open.svg';
import MC_CLOSE from './mc_lid_close.svg';
import MC_BALANCE from './mc_balance.svg';
import MC_CONTROLS from './mc_controls.svg';
import EJECT_TUBE from './mc_eject_tube.svg';
import EJECT_ROTOR from './mc_eject_rotor.svg';
import {TUBE_TYPES} from '../Microcentrifuge.utils';
const BALANCE_MIN_SLOTS = 2;

export function useMicroTooltipControls() {
  const showEjectTube = (slots) => slots.some((item) => item.solution);

  const showEjectRotor = (slots) => {
    let hasRotor = slots.some((item) => item.rotor);
    return slots.reduce((show, item) => {
      if (show) {
        if (item.tubeType === TUBE_TYPES.PCR) {
          if (item.solution === true) {
            show = false;
          }
        }
      }
      return show;
    }, hasRotor);
  };

  const showBalance = (slots) =>
    slots.filter((item) => item.tubeType).length >= BALANCE_MIN_SLOTS;

  const getControlItems = (props) => {
    const newControlItems = [];
    const ejectTube = showEjectTube(props.slots);
    const ejectRotor = showEjectRotor(props.slots);
    const balance = showBalance(props.slots);

    if (!props.isOpen) {
      newControlItems.push({
        onClick: props.openShowControlsModal,
        image: MC_CONTROLS,
      });
      newControlItems.push({
        onClick: props.toggleLid,
        image: MC_OPEN,
      });
    } else {
      newControlItems.push({
        onClick: props.toggleLid,
        image: MC_CLOSE,
      });
    }
    if (props.isOpen && ejectTube) {
      newControlItems.push({
        onClick: props.onEjectTube,
        image: EJECT_TUBE,
      });
    }
    if (props.isOpen && ejectRotor) {
      newControlItems.push({
        onClick: props.onEjectRotor,
        image: EJECT_ROTOR,
      });
    }
    if (props.isOpen && balance) {
      newControlItems.push({
        onClick: props.openBalanceModal,
        image: MC_BALANCE,
      });
    }
    return newControlItems;
  };

  return {getControlItems};
}
